/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from 'react'
import { useApp } from '@/core/contexts/app'

import Image from '@/components/base/image'

import type { OptScreenProps } from './types'
import Button from '@/components/base/button/Button'
import axios from 'axios'
import { Column, Container, Row } from '@/components/base/gridview'
import Icon from '@/components/base/icon'
import { Rings } from 'react-loading-icons'

const OptScreen: React.FunctionComponent<OptScreenProps> = ({
  title,
  logo,
  desc,
}) => {
  const [phoneData, setPhoneData] = useState<string>('')
  const [createData, setcreateData] = useState<any>()
  const [isCorrect, setIsCorrect] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState(false)
  const [phoneErr, setPhoneErr] = useState<boolean>(false)
  const app = useApp()
  const phoneServiceCreate = () => {
    let formatPhone = phoneData.replace(/\s/g, '')
    const postData = {
      columns: [
        {
          name: 'phoneNumber',
          data: { refs: ['string'], value: formatPhone },
        },
      ],
    }
    if (formatPhone?.length === 11) {
      setIsLoading(true)
      setPhoneErr(false)
      axios
        .post(
          'https://integration-api.tga.gov.tr/suggestionuserv2/create-otp',
          postData
        )
        .then(function (response) {
          localStorage.setItem('userPhone', formatPhone)
          setcreateData(response.data)
        })
        .catch(function (error) {
          setIsLoading(false)
          console.log(error)
        })
    } else {
      setPhoneErr(true)
    }
  }

  useEffect(() => {
    if (createData) {
      window.location.href = `otp-page`
      setIsCorrect(true)
    }
  }, [createData])
  const handlePhoneChange = (e: any) => {
    const enteredValue = e.target.value.replace(/([()])/g, '').replace(/ /g, '')

    if (enteredValue) {
      if (enteredValue[0] === '0') {
        const groups = [
          enteredValue.slice(0, 4),
          enteredValue.slice(4, 7),
          enteredValue.slice(7, 11),
        ]
        setPhoneData(groups.filter((group) => group).join(' '))
      }
    }
  }

  return (
    <div className="form background-container">
      <div className="form_container" style={{ maxWidth: '400px' }}>
        <Container>
          <Row>
            <Column md={{ size: 12 }}>
              <div className="form_logo">
                <img
                  src={`https://cdn.tga.net.tr/${logo?.src}`}
                  alt=""
                  width={logo?.width || 200}
                  height={logo?.height}
                />
                {/* {logo && <Image {...logo} alt={title} loading="eager" />} */}
              </div>
            </Column>
          </Row>
          <Row>
            <Column md={{ size: 12 }}>
              <div className="form_title">
                <h4>{title}</h4>
                <p>{desc} </p>
              </div>
            </Column>
          </Row>
          <Row>
            <Column md={{ size: 12 }}>
              <div className="form_phone">
                <input
                  type="text"
                  placeholder="0-599-999-99-99"
                  value={phoneData}
                  onChange={handlePhoneChange}
                />
              </div>
            </Column>
          </Row>
          <Row>
            {isLoading ? (
              <Column>
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                  <Rings stroke="#4a90e2" strokeWidth={4} />
                </div>
              </Column>
            ) : (
              <Column>
                <div className="form_button">
                  <Button
                    disabled={phoneData.length !== 13 ? true : false}
                    appearance="default"
                    onClick={() => {
                      phoneServiceCreate()
                    }}
                  >
                    Doğrulama Kodu Gönder
                  </Button>
                </div>
              </Column>
            )}
          </Row>
        </Container>
      </div>
    </div>
  )
}

export default OptScreen
